import o, { css as i } from "styled-components";
import e from "../../utils/colors.js";
import { device as r } from "../../utils/device.js";
const d = o.div`
  transition: all 0.5s ease-out;
  width: 15px;
  height: 15px;
  padding-right: 8px;
  box-sizing: content-box; // normally not needed to be explicit, but SiteCore has a different base style
  font-size: 0; // not normally needed, but the inherited SiteCore styling causes this to be misaligned

  svg {
    transition: all 0.5s ease-out;
  }
`, s = o.div`
  transition: all 0.5s ease-out;
  height: 24px;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.3px;
  text-align: center;
  word-break: keep-all;
  color: ${e.blueGrey};

  @media ${r.isDesktop}, ${r.isTablet} {
    height: 24px;
    letter-spacing: -0.3px;
  }
`, p = o.button`
  transition: all 0.5s ease-out;
  display: flex;
  justify-content: ${(t) => t.$styleType === "largeWithBorder" ? "center" : "flex-start"};
  align-items: center;
  text-decoration: none;
  font-family: VIC;
  box-sizing: border-box;
  vertical-align: middle;
  word-break: break-all;
  flex-wrap: nowrap;
  cursor: pointer;
  border-radius: 2px;
  background-color: ${e.white};
  border: ${(t) => t.$styleType === "largeWithBorder" ? `1px solid ${e.blueGrey}` : "none"};
  width: 100%;
  height: 50px;
  padding-left: ${(t) => t.$styleType === "largeWithBorder" ? "16px" : "4px"};
  padding-right: 16px;

  ${(t) => t.disabled ? i`
          div {
            color: ${e.darkGrey75};
          }

          svg {
            &.add {
              stroke: ${e.darkGrey75};
            }

            &.change,
            &.delete,
            &.download,
            &.cancel {
              fill: ${e.darkGrey75};
            }
          }
        ` : i`
          ${t.$styleType === "largeWithBorder" ? `
          :hover {
            border-color: ${e.orange};
          }
        ` : null}

          &:hover div,
          &:focus div {
            color: ${e.orange};

            .add {
              stroke: ${e.orange};
            }

            .change,
            .delete,
            .download,
            .cancel {
              fill: ${e.orange};
            }
          }
        `}

  @media ${r.isDesktop}, ${r.isTablet} {
    max-width: 350px;
  }
`;
export {
  d as TaskButtonIconWrapper,
  p as TaskButtonWrapper,
  s as TextWrapper
};
